import { type ITablePaginadaBasicProps } from "@/Components/Base/Table/TablePaginadaBasic";
import type Feriado from "@/Models/geral/data/Feriado";
import TablePaginadaBasic from "@/Components/Base/Table/TablePaginadaBasic";
import Ordenar from "@/Utils/Ordenacao";
import { Button, Flex, Popconfirm } from "antd";
import { useFeriadoDesativar } from "@/Services/geral/data/FeriadoService";
import { DeleteOutlined } from "@ant-design/icons";
import { type EnumMes, MesLista } from "@/Models/geral/data/Mes";

export interface IContaViagemTableProps extends Omit<ITablePaginadaBasicProps<Feriado>, "rowKey"> {
    onSuccess ?: () => void;
}

export default function FeriadoTable({
    columns,
    bordered,
    locale,
    loading,
    size,
    onSuccess,
    ...props
}:IContaViagemTableProps) {
    return <TablePaginadaBasic
        {...props}
        bordered={bordered ?? true}
        locale={{ ...locale, emptyText: locale?.emptyText ?? 'Nenhum feriado foi encontrado.' }}
        loading={loading}
        rowKey={(k) => k.codigo}
        size={size === undefined ? "small" : size}
        showHeader={true}
        disableResponsiveness={true}
        tableLayout="auto"
        scroll={{
            x : undefined,
            y : "70vh"
        }}
        columns={
            [
                {
                    title: "Ano",
                    dataIndex: ["ano"],
                    render(value:number, _:Feriado, __:number) {
                        return value ?? "Todos";
                    },
                    key: 50
                },
                {
                    title: "Dia",
                    dataIndex: ["mes"],
                    render(value:EnumMes, record:Feriado, __:number) {
                        return `${record.dia.toString().padStart(2, '0')} de ${MesLista.find(f => f.value == value)!.label.substring(0, 3)}`;
                    },
                    key: 51
                },
                // {
                //     title: "Estado",
                //     dataIndex: ["estado", "sigla"],
                //     render(value:string, _:Feriado, __:number) {
                //         return value ?? "Todos";
                //     },
                //     key: 52
                // },
                // {
                //     title: "Município",
                //     dataIndex: ["municipio", "nome"],
                //     render(value:string, _:Feriado, __:number) {
                //         return value ?? "Todos";
                //     },
                //     key: 53
                // },
                {
                    title: "Nome",
                    dataIndex: ["nome"],
                    key: 54
                },
                {
                    title : "Ações",
                    dataIndex : ["codigo"],
                    render(_:number, record:Feriado) {
                        return <OpcoesFeriado feriado={record} onSuccess={onSuccess} />;
                    },
                    key : 55
                },
                ...(columns ?? [])
            ].sort((coluna1, coluna2) => Ordenar.Numero(Number(coluna1.key), Number(coluna2.key)))
        }
    />
}

export function OpcoesFeriado({
    feriado,
    onSuccess
}:{
    feriado:Feriado;
    onSuccess ?: () => void;
}) {
    const {
        mutate,
        isPending
    } = useFeriadoDesativar({ 
        onSuccess(data, variables, context) {
            onSuccess?.();
        },
    });

    return <Flex vertical={false} wrap="wrap" gap={"small"}>
        <Popconfirm
            title={"Remover feriado"}
            description={"Tem certeza que deseja remover este feriado?"}
            onConfirm={() => mutate(feriado)}
            okButtonProps={{
                loading : isPending
            }}
        >
            <Button danger size="small" icon={<DeleteOutlined />} />
        </Popconfirm>
    </Flex>;
}